<template>
  <f7-page id="tnc-page" name="tnc-page" @page:afterin="afterin">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link @click="navigateBack()" class="customBack" color="black"><i class="f7-icons">chevron_left</i></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>
    <f7-block>
      <div class="col-70 text-align-left mb-xl">
          <div class="wandr-title-1 wandr-level-2">{{$t('invite-earn-tnc-title')}}</div>
          <!-- <div class="wandr-subtitle-1">{{$t('general-text-updated')}} {{updatedDate}}</div> -->
      </div>
			<div class="static-content" @click="handleDOMTNCLink($event)" v-html="tncContent.details">
			</div>
    </f7-block>
  </f7-page>
</template>

<style scoped>
em{
  font-style: italic;
}

</style>

<script>
  import { translation } from '@/plugins/i18n'
  import { mapGetters } from "vuex"

  export default {
    data() {
      return {
        tncContent  : [],
        updatedDate : '',
      };
    },

    mounted (){
      const moment = require('moment')
      const today  = new Date()
      const yyyy   = today.getFullYear()
      let mm       = today.getMonth() + 1 // Months start at 0!
      let dd       = today.getDate()


      let formattedMonth = moment(mm, 'M').locale(translation.currentLanguage).format('MMMM')

      this.updatedDate = dd + ' ' + formattedMonth + ' ' + yyyy
      this.loadTNC()
    },
    computed: {
      ...mapGetters('auth', ['loggedIn'])
    },

    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async loadTNC(){
        const self = this
        self.showPreloader()

        const loadTnc =  await this.$api.registration.getTnc(8, 36)
        self.tncContent = loadTnc

        self.hidePreloader()
      },

      handleDOMTNCLink(event){
        if(event.target.id == "navigate-to-term-and-condition-internal"){
          if(this.loggedIn){
            this.$f7router.navigate("/terms-and-condition" , { transition: 'f7-push'});
          }else{
            this.$f7router.navigate("/guest-tnc" , { transition: 'f7-push'});
          }
        }else if(event.target.id == "invite-earn-tnc-internal"){
          const appRedirPath = this.$api.misc.checkDeviceRedirect()
          if(appRedirPath){
            window.location.href = appRedirPath; return;
          }else{
            this.openPage("https://wandr-e.com/mobileappdownload")
          }
        }else if(event.target.id == "invite-earn-tnc-online-internal" || event.target.id == "invite-earn-tnc-online-internal-2"){
          this.openPage(process.env.VUE_APP_MARKETING)
        }
      },

      openPage(link){
        if(window.Android) {
          window.Android.getWandrCallback(JSON.stringify({ "type": 'open_page','data': link}));
        } else if(window.webkit) {
          window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'open_page', 'data': link}));
        } else {
          window.open(link);
        }
      },

      navigateBack(){
        this.$f7router.back({ transition: 'f7-push' })
      }
    },
  }
</script>
